import React, { forwardRef } from 'react';

interface InsightCardProps {
  distilledInsight: string;
  topic?: string;
  toneTags?: string[];
  hook?: string;
}

const InsightCard = forwardRef<HTMLDivElement, InsightCardProps>(
  ({ distilledInsight, topic, toneTags = [] }, ref) => {
    return (
      <div
        ref={ref}
        style={{
          position: 'absolute',
          left: '-9999px',
          top: '-9999px',
          width: '800px',
          height: '800px',
          background: '#0f0e0d',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: '72px',
          fontFamily: "'Bricolage Grotesque', 'Inter', sans-serif",
          boxSizing: 'border-box',
        }}
      >
        {/* Top — brand */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div
            style={{
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: '#c9a84c',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px',
              fontWeight: 800,
              color: '#0f0e0d',
            }}
          >
            d
          </div>
          <span style={{ fontSize: '13px', fontWeight: 700, color: 'rgba(255,255,255,0.35)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
            distill
          </span>
        </div>

        {/* Middle — insight */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '40px 0' }}>
          <div
            style={{
              fontSize: '56px',
              fontWeight: 300,
              color: '#c9a84c',
              lineHeight: 0.9,
              marginBottom: '32px',
              fontFamily: 'Georgia, serif',
            }}
          >
            "
          </div>
          <div
            style={{
              fontSize: distilledInsight.length > 100 ? '28px' : '34px',
              fontWeight: 700,
              color: '#ffffff',
              lineHeight: 1.35,
              letterSpacing: '-0.02em',
            }}
          >
            {distilledInsight}
          </div>
        </div>

        {/* Bottom — topic + tags + watermark */}
        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {topic && (
              <span
                style={{
                  fontSize: '12px',
                  fontWeight: 700,
                  color: '#c9a84c',
                  background: 'rgba(201,168,76,0.12)',
                  padding: '4px 12px',
                  borderRadius: '100px',
                  border: '1px solid rgba(201,168,76,0.3)',
                }}
              >
                {topic}
              </span>
            )}
            {toneTags.slice(0, 3).map((t) => (
              <span
                key={t}
                style={{
                  fontSize: '11px',
                  fontWeight: 500,
                  color: 'rgba(255,255,255,0.4)',
                  background: 'rgba(255,255,255,0.06)',
                  padding: '4px 10px',
                  borderRadius: '100px',
                }}
              >
                {t}
              </span>
            ))}
          </div>
          <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.2)', fontWeight: 600, letterSpacing: '0.04em' }}>
            distill.app
          </div>
        </div>
      </div>
    );
  }
);

InsightCard.displayName = 'InsightCard';
export default InsightCard;
